import { buildCollection, buildProperty } from "@firecms/core";

export type Member = {
  name: string;
  email: string;
  roles: string[];
};

export const teamMembersCollection = buildCollection<Member>({
  id: "team",
  name: "Team",
  singularName: "Member",
  textSearchEnabled: true,
  path: "team",
  permissions: ({ authController }) => {
    const isAdmin = authController.extra?.roles.includes("admin") ?? false;
    return {
      edit: isAdmin,
      create: isAdmin,
      delete: isAdmin,
    };
  },
  properties: {
    name: buildProperty({
      name: "Name",
      validation: { required: true },
      dataType: "string",
    }),
    email: buildProperty({
      name: "Email",
      validation: { required: false },
      dataType: "string",
    }),
    roles: buildProperty({
      name: "Roles",
      validation: { required: false },
      dataType: "array",
      of: {
        dataType: "string",
        enumValues: {
          admin: "Admin",
          csm: "CSM",
          pls: "PLS",
        },
      },
    }),
  },
});
